import { graphql } from "@/gql";

export const reportIncidentMutation = graphql(`
  mutation ReportIncident($input: ReportIncidentInput!) {
    reportIncident(input: $input) {
      id
      reference
    }
  }
`);
